/* eslint-disable max-lines */

import React, { ComponentType } from 'react';
import AddigyIcon from '../../src/icons/Addigy';
import AirtableIcon from '../../src/icons/Airtable';
import AirWatchIcon from '../../src/icons/AirWatch';
import ArtifactoryIcon from '../../src/icons/Artifactory';
import AtSpokeIcon from '../../src/icons/AtSpoke';
import Auth0Icon from '../../src/icons/Auth0';
import AutomoxIcon from '../../src/icons/Automox';
import AWSIcon from '../../src/icons/Aws';
import AzDevOpsIcon from '../../src/icons/AzDevOps';
import AzureIcon from '../../src/icons/Azure';
import BambooHRIcon from '../../src/icons/BambooHR';
import BitbucketIcon from '../../src/icons/Bitbucket';
import BugcrowdIcon from '../../src/icons/Bugcrowd';
import CarbonBlackIcon from '../../src/icons/CarbonBlack';
import CheckmarxIcon from '../../src/icons/Checkmarx';
import CiscoAmpIcon from '../../src/icons/CiscoAmp';
import CiscoMerakiIcon from '../../src/icons/CiscoMeraki';
import CloudflareIcon from '../../src/icons/Cloudflare';
import CobaltIcon from '../../src/icons/Cobalt';
import CrowdStrikeIcon from '../../src/icons/CrowdStrike';
import DetectifyIcon from '../../src/icons/Detectify';
import DigiCertIcon from '../../src/icons/DigiCert';
import DuoIcon from '../../src/icons/Duo';
import FastlyIcon from '../../src/icons/Fastly';
import FerootIcon from '../../src/icons/Feroot';
import GitHubIcon from '../../src/icons/GitHub';
import GitLabIcon from '../../src/icons/GitLab';
import GoDaddyIcon from '../../src/icons/GoDaddy';
import GoogleIcon from '../../src/icons/Google';
import GoogleCloudIcon from '../../src/icons/GoogleCloud';
import HackerOneIcon from '../../src/icons/HackerOne';
import HerokuIcon from '../../src/icons/Heroku';
import JamfIcon from '../../src/icons/Jamf';
import JiraIcon from '../../src/icons/Jira';
import JumpCloudIcon from '../../src/icons/JumpCloud';
import KnowBe4Icon from '../../src/icons/KnowBe4';
import KubernetesIcon from '../../src/icons/Kubernetes';
import MalwarebytesIcon from '../../src/icons/Malwarebytes';
import NmapIcon from '../../src/icons/Nmap';
import NowSecureIcon from '../../src/icons/NowSecure';
import NpmIcon from '../../src/icons/Npm';
import Microsoft365Icon from '../icons/Microsoft365';
import OktaIcon from '../../src/icons/Okta';
import OneLoginIcon from '../../src/icons/OneLogin';
import OpenShiftIcon from '../../src/icons/OpenShift';
import PagerDutyIcon from '../../src/icons/PagerDuty';
import QualysIcon from '../../src/icons/Qualys';
import Rapid7Icon from '../../src/icons/Rapid7';
import SalesforceIcon from '../icons/Salesforce';
import SamanageIcon from '../../src/icons/Samanage';
import SentinelOneIcon from '../../src/icons/SentinelOne';
import ServiceNowIcon from '../../src/icons/ServiceNow';
import SlackIcon from '../../src/icons/Slack';
import SnipeItIcon from '../../src/icons/SnipeIt';
import SnowflakeIcon from '../../src/icons/Snowflake';
import SnykIcon from '../../src/icons/Snyk';
import SonarQubeIcon from '../../src/icons/SonarQube';
import TenableCloudIcon from '../../src/icons/TenableCloud';
import ThreatStackIcon from '../../src/icons/ThreatStack';
import TrendMicroIcon from '../../src/icons/TrendMicro';
import VeracodeIcon from '../../src/icons/Veracode';
import WazuhIcon from '../../src/icons/Wazuh';
import WhiteHatIcon from '../../src/icons/WhiteHat';
import WhoisIcon from '../../src/icons/Whois';
import WPEngineIcon from '../../src/icons/WPEngine';
import ZeitIcon from '../../src/icons/Zeit';
import ZendeskIcon from '../../src/icons/Zendesk';
import { GenericIntegrationIconProps } from '../types';

const { default: DefaultIcon } = require('react-feather/dist/icons/zap');

interface IconMap {
  [key: string]: ComponentType<GenericIntegrationIconProps>;
}

export interface IntegrationIconProps extends GenericIntegrationIconProps {
  integrationTitle: string;
}

export const iconMappings: IconMap = {
  Addigy: AddigyIcon,
  Airtable: AirtableIcon,
  AirWatch: AirWatchIcon,
  Artifactory: ArtifactoryIcon,
  atSpoke: AtSpokeIcon,
  Auth0: Auth0Icon,
  Automox: AutomoxIcon,
  AWS: AWSIcon,
  'Azure DevOps': AzDevOpsIcon,
  Azure: AzureIcon,
  BambooHR: BambooHRIcon,
  Bitbucket: BitbucketIcon,
  Bugcrowd: BugcrowdIcon,
  'Carbon Black PSC': CarbonBlackIcon,
  Checkmarx: CheckmarxIcon,
  Cloudflare: CloudflareIcon,
  'Cisco AMP': CiscoAmpIcon,
  'Cisco Meraki': CiscoMerakiIcon,
  Cobalt: CobaltIcon,
  CrowdStrike: CrowdStrikeIcon,
  Detectify: DetectifyIcon,
  DigiCert: DigiCertIcon,
  Duo: DuoIcon,
  Fastly: FastlyIcon,
  Feroot: FerootIcon,
  HackerOne: HackerOneIcon,
  Heroku: HerokuIcon,
  GitHub: GitHubIcon,
  GitLab: GitLabIcon,
  GoDaddy: GoDaddyIcon,
  Google: GoogleIcon,
  'Google Cloud': GoogleCloudIcon,
  Jira: JiraIcon,
  Jamf: JamfIcon,
  JumpCloud: JumpCloudIcon,
  KnowBe4: KnowBe4Icon,
  'Kubernetes Native': KubernetesIcon,
  Malwarebytes: MalwarebytesIcon,
  Nmap: NmapIcon,
  NowSecure: NowSecureIcon,
  npm: NpmIcon,
  'Microsoft 365': Microsoft365Icon,
  Okta: OktaIcon,
  OneLogin: OneLoginIcon,
  OpenShift: OpenShiftIcon,
  PagerDuty: PagerDutyIcon,
  Qualys: QualysIcon,
  Rapid7: Rapid7Icon,
  Salesforce: SalesforceIcon,
  Samanage: SamanageIcon,
  SentinelOne: SentinelOneIcon,
  ServiceNow: ServiceNowIcon,
  Slack: SlackIcon,
  'Snipe-IT': SnipeItIcon,
  Snowflake: SnowflakeIcon,
  Snyk: SnykIcon,
  SonarQube: SonarQubeIcon,
  'Tenable.io': TenableCloudIcon,
  'Threat Stack': ThreatStackIcon,
  'Trend Micro': TrendMicroIcon,
  Veracode: VeracodeIcon,
  Wazuh: WazuhIcon,
  WhiteHat: WhiteHatIcon,
  Whois: WhoisIcon,
  'WP Engine': WPEngineIcon,
  Zeit: ZeitIcon,
  Zendesk: ZendeskIcon,
};

export const integrationList: string[] = [
  'Addigy',
  'Airtable',
  'AirWatch',
  'atSpoke',
  'Auth0',
  'Automox',
  'AWS',
  'Azure',
  'Azure DevOps',
  'BambooHR',
  'Bitbucket',
  'Bugcrowd',
  'Carbon Black PSC',
  'Cloudflare',
  'Cisco AMP',
  'Cisco Meraki',
  'Cobalt',
  'CrowdStrike',
  'Detectify',
  'DigiCert',
  'Duo',
  'GitHub',
  'GitLab',
  'Google',
  'Google Cloud',
  'HackerOne',
  'Heroku',
  'Jira',
  'Jamf',
  'JumpCloud',
  'KnowBe4',
  'Kubernetes Native',
  'Malwarebytes',
  'Nmap',
  'NowSecure',
  'npm',
  'Office 365',
  'Okta',
  'OneLogin',
  'OpenShift',
  'PagerDuty',
  'Qualys',
  'Rapid7',
  'Salesforce',
  'Samanage',
  'SentinelOne',
  'ServiceNow',
  'Slack',
  'Snipe-IT',
  'Snowflake',
  'Snyk',
  'SonarQube',
  'Tenable Cloud',
  'Threat Stack',
  'Trend Micro',
  'Veracode',
  'Wazuh',
  'WhiteHat',
  'Whois',
  'WP Engine',
  'Zeit',
  'Zendesk',
];

const integrationTypeMappings: { [key: string]: string } = {
  addigy: 'Addigy',
  airtable: 'Airtable',
  airwatch: 'AirWatch',
  atspoke: 'atSpoke',
  auth0: 'Auth0',
  automox: 'Automox',
  aws: 'AWS',
  azure: 'Azure',
  'azure-devops': 'Azure DevOps',
  bamboohr: 'BambooHR',
  bitbucket: 'Bitbucket',
  bugcrowd: 'Bugcrowd',
  cbdefense: 'Carbon Black PSC',
  cloudflare: 'Cloudflare',
  ciscoamp: 'Cisco AMP',
  ciscomeraki: 'Cisco Meraki',
  cobalt: 'Cobalt',
  crowdstrike: 'CrowdStrike',
  detectify: 'Detectify',
  digicert: 'DigiCert',
  duo: 'Duo',
  github: 'GitHub',
  gitlab: 'GitLab',
  google: 'Google',
  googlecloud: 'Google Cloud',
  hackerone: 'HackerOne',
  heroku: 'Heroku',
  jira: 'Jira',
  jamf: 'Jamf',
  jumpcloud: 'JumpCloud',
  knowbe4: 'KnowBe4',
  kubernetes: 'Kubernetes',
  malwarebytes: 'Malwarebytes',
  nmap: 'Nmap',
  nowsecure: 'NowSecure',
  npm: 'npm',
  microsoft365: 'Microsoft 365',
  okta: 'Okta',
  onelogin: 'OneLogin',
  openshift: 'OpenShift',
  pagerduty: 'PagerDuty',
  qualys: 'Qualys',
  rapid7: 'Rapid7',
  salesforce: 'Salesforce',
  samanage: 'Samanage',
  sentinelone: 'SentinelOne',
  servicenow: 'ServiceNow',
  slack: 'Slack',
  snipeit: 'Snipe-IT',
  snowflake: 'Snowflake',
  snyk: 'Snyk',
  sonarqube: 'SonarQube',
  'tenable-cloud': 'Tenable Cloud',
  threatstack: 'Threat Stack',
  trendmicro: 'Trend Micro',
  veracode: 'Veracode',
  wazuh: 'Wazuh',
  whitehat: 'WhiteHat',
  whois: 'Whois',
  wpengine: 'WP Engine',
  zeit: 'Zeit',
  zendesk: 'Zendesk',
};

// A higher-order component? After React 16.8?? What am I thinking!!??!??
export function getIntegrationIcon(
  Icon?: ComponentType<GenericIntegrationIconProps>
): ComponentType<GenericIntegrationIconProps> {
  return function GenericIntegrationIcon(props: GenericIntegrationIconProps) {
    return Icon ? (
      <Icon {...props} />
    ) : (
      <DefaultIcon
        size={props.size}
        style={{
          stroke: '#FFFFFF',
          strokeOpacity: 0.5,
          strokeWidth: 1,
          ...props.style,
        }}
        className={props.className}
      />
    );
  };
}

/**
 * Hack for fetching an icon for an integration
 * until a proper method is found
 */
export const IntegrationIcon = ({
  integrationTitle,
  ...props
}: IntegrationIconProps) => {
  const Icon = getIntegrationIcon(iconMappings[integrationTitle]);
  return <Icon {...props} />;
};

/**
 * Same deal, but fetching an icon for an integration
 * type, specified by the _integrationType property
 */
export const getIntegrationIconForType = (
  integrationType: string
): ComponentType<GenericIntegrationIconProps> | null => {
  const title = integrationTypeMappings[integrationType];
  if (!title) return null;
  const Icon = iconMappings[title];
  return getIntegrationIcon(Icon);
};
